import { render, staticRenderFns } from "./fndisclamier.vue?vue&type=template&id=0f2ac9a6&"
import script from "./fndisclamier.vue?vue&type=script&lang=js&"
export * from "./fndisclamier.vue?vue&type=script&lang=js&"
import style0 from "./fndisclamier.vue?vue&type=style&index=0&id=0f2ac9a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports